//DESENVOLVIMENTO
export const URL_API        =  process.env.REACT_APP_URL_API
//export const KEYCLOACK_URL  =  "https://keycloak-hom.fazenda.mg.gov.br/"
//export const KEYCLOACK_REALM = "distvaf"

//HOMOLOGACAO
//export const URL_API        =  "https://distvaf-backend-dev.odiceu.fazenda.mg.gov.br"
//export const URL_API        =  "https://distvaf-backend-stg.faenna.fazenda.mg.gov.br/"
export const KEYCLOACK_URL  =  process.env.REACT_APP_KEYCLOACK_URL
export const KEYCLOACK_REALM = process.env.REACT_APP_KEYCLOACK_REALM

//PRODUÇAO
//export const URL_API        =  "https://distvaf-backend-prd.ulisses.fazenda.mg.gov.br/"
//export const KEYCLOACK_URL  =  "https://acesso.fazenda.mg.gov.br/"
//export const KEYCLOACK_REALM = "intranet"

//export const URL_API        =  process.env.REACT_APP_URL_API
//export const KEYCLOACK_URL  =  process.env.REACT_APP_KEYCLOACK_URL
//export const KEYCLOACK_REALM = process.env.REACT_APP_KEYCLOACK_REALM

//export const REACT_APP_URL_API   =  process.env.REACT_APP_URL_API
//export const REACT_APP_KEYCLOACK_URL   =  process.env.KEYCLOACK_URL

//export const URL_API_DEV = "http://localhost:8080/distvaf"
//export const URL_API_NEREU = "http://nereu.fazenda.mg.gov.br:8080/distvaf" https://hdistvaf-backend.fazenda.mg.gov.br/distvaf
//export const URL_API_NICON = "http://nicon.fazenda.mg.gov.br:8080/distvaf"  https://distvaf-backend.fazenda.mg.gov.br/distvaf

